import React, { useState } from 'react'
import {
  Box,
  Stack,
  Typography,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { SaleIntegrityPageTable } from '../../components/Table/SaleIntegrityPageTable'
import { useGetDealerSaleQuery } from '../../redux/api/SaleIntegrityApi'
import { SaleIntegrityForm } from './SaleIntegrityForm'
import { SaleIntegrity } from '../../types/SaleIntegrity'

const styles = {
  container: {
    padding: '32px 24px 64px',
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  searchInput: {
    width: '100%',
    marginRight: '10px',
  },
}
const loaderBox = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}

export const SaleIntegrityPage = () => {
  const [searchKey, setSearchKey] = useState('')
  const [editingStatus, setEditingStatus] = useState<SaleIntegrity | null>(null)

  const { data, isLoading, refetch } = useGetDealerSaleQuery()

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKey(event.target.value)
  }

  const handleEditStatus = (status: SaleIntegrity) => {
    setEditingStatus(status)
  }

  const handleCloseForm = () => {
    setEditingStatus(null)
  }

  return (
    <React.Fragment>
      <Box sx={styles.container}>
        <Stack direction='row' justifyContent='space-between' mb={2} mr={1}>
          <Typography variant='h4' color='#1E90FF'>
            Sale to Contract Integrity
          </Typography>
          <Stack direction='row' alignItems='center'>
            <OutlinedInput
              placeholder='Search'
              onChange={handleSearchChange}
              endAdornment={
                <InputAdornment position='end'>
                  <SearchIcon />
                </InputAdornment>
              }
              sx={{ marginRight: '20px' }}
            />
          </Stack>
        </Stack>

        {isLoading ? (
          <Box sx={loaderBox}>
            <CircularProgress />
          </Box>
        ) : (
          <SaleIntegrityPageTable
            isLoading={isLoading}
            rows={data || []}
            searchKey={searchKey}
            editStatus={handleEditStatus}
            refetch={refetch}
          />
        )}

        <SaleIntegrityForm
          open={!!editingStatus}
          onClose={handleCloseForm}
          saleIntegrityData={editingStatus}
        />
      </Box>
    </React.Fragment>
  )
}
